import styled from "styled-components";

export const MainContainerStyled = styled.div`
  display: flex;
  margin-top: 2.5rem;

  .text {
    flex-grow: 5;
  }
`;
